import createIcon from '../../createIcon';

/**
 * @component @name MoreVert
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgOEMxMy4xIDggMTQgNy4xIDE0IDZDMTQgNC45IDEzLjEgNCAxMiA0QzEwLjkgNCAxMCA0LjkgMTAgNkMxMCA3LjEgMTAuOSA4IDEyIDhaTTEyIDEwQzEwLjkgMTAgMTAgMTAuOSAxMCAxMkMxMCAxMy4xIDEwLjkgMTQgMTIgMTRDMTMuMSAxNCAxNCAxMy4xIDE0IDEyQzE0IDEwLjkgMTMuMSAxMCAxMiAxMFpNMTIgMTZDMTAuOSAxNiAxMCAxNi45IDEwIDE4QzEwIDE5LjEgMTAuOSAyMCAxMiAyMEMxMy4xIDIwIDE0IDE5LjEgMTQgMThDMTQgMTYuOSAxMy4xIDE2IDEyIDE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MoreVert = createIcon('MoreVert', [
  [
    'path',
    {
      d: 'M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z',
      key: '1l5im4',
    },
  ],
]);

export default MoreVert;
